"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _priceBlock = require("@site/price-block");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _box = _interopRequireDefault(require("@ux/box"));
var _button = _interopRequireDefault(require("@ux/button"));
var _addToCart = _interopRequireDefault(require("@ux/icon/add-to-cart"));
var _space = _interopRequireWildcard(require("@ux/space"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _text = _interopRequireDefault(require("@ux/text"));
var _PromptRecommendations = require("../../styles/PromptRecommendations");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO: [USIDOM-1465] clean up file to use conversation search

const DomainRecommendation = ({
  recommendation,
  product,
  onAddToCart,
  disabled,
  isListPricePriority,
  stackDomainAndPrice
}) => {
  const {
    formatMessage,
    messages
  } = (0, _reactMintl.useIntl)();
  const {
    domainName,
    extension,
    nameWithoutExtension,
    domainObject,
    isRestricted
  } = recommendation;
  const [isAddingToCart, setIsAddingToCart] = (0, _react.useState)(false);
  const [isAddingToCartError, setIsAddingToCartError] = (0, _react.useState)(false);
  const handleAddToCart = async () => {
    setIsAddingToCart(true);
    const addToCartStatus = await onAddToCart({
      product,
      domainName,
      isRestricted
    });
    if (addToCartStatus === _constants.REQUEST_STATUS.FAIL || addToCartStatus === _constants.REQUEST_STATUS.UNAVAILABLE) {
      setIsAddingToCartError(true);
    }
    setIsAddingToCart(false);
  };
  const nameAndPriceFlexProps = stackDomainAndPrice ? {
    orientation: 'vertical'
  } : {
    orientation: 'horizontal',
    inlineAlignChildren: 'center'
  };
  return /*#__PURE__*/_react.default.createElement(_PromptRecommendations.StyledDomainRecommendation, {
    orientation: "horizontal",
    gap: "sm",
    inlineAlignChildren: "center",
    blockAlignChildren: "center"
  }, /*#__PURE__*/_react.default.createElement(_box.default, (0, _extends2.default)({}, nameAndPriceFlexProps, {
    stretch: true,
    className: "name-and-price"
  }), /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    size: stackDomainAndPrice ? -1 : 0,
    "data-testid": "domain-recommendation-domain-name",
    className: (0, _classnames.default)('margin-bottom-0', 'domain-name-container')
  }, /*#__PURE__*/_react.default.createElement("strong", null, nameWithoutExtension, "."), /*#__PURE__*/_react.default.createElement("strong", {
    className: "break-tld"
  }, extension)), stackDomainAndPrice && /*#__PURE__*/_react.default.createElement(_space.default.div, {
    block: _space.sizeOptions.SM
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "domain-recommendation-price-block",
    className: "price-block-container"
  }, /*#__PURE__*/_react.default.createElement(_priceBlock.StandardPriceBlock, {
    domain: domainObject,
    product: product,
    language: messages,
    options: {
      isListPricePriority,
      classNames: {
        priceBlock: 'price-block',
        priceCurrent: 'pricing-main-price',
        priceInitial: 'pricing-initial-price',
        priceDisclaimerWrapper: true,
        styleOptions: {
          addPriceLineMarginTop: false,
          addPriceBlockMarginRight: false,
          alignRight: false
        }
      }
    }
  }))), !isAddingToCartError &&
  /*#__PURE__*/
  // wrap in div to avoid flexbox from stretching the button
  _react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "small",
    disabled: disabled,
    design: "secondary",
    className: "add-to-cart-button",
    "aria-label": formatMessage({
      id: 'searchRecommendation.domain.cart.add'
    }),
    onClick: handleAddToCart,
    active: isAddingToCart,
    icon: isAddingToCart ?
    /*#__PURE__*/
    // styles to avoid button size form changing when clicked
    _react.default.createElement("div", {
      className: "cart-button-spinner"
    }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
      size: "sm"
    })) : /*#__PURE__*/_react.default.createElement(_addToCart.default, null)
  })), isAddingToCartError && /*#__PURE__*/_react.default.createElement(_text.default.div, {
    role: "alert",
    text: formatMessage({
      id: 'searchRecommendation.domain.cart.error'
    })
  }));
};
DomainRecommendation.propTypes = {
  recommendation: _propTypes.default.shape({
    domainName: _propTypes.default.string,
    extension: _propTypes.default.string,
    nameWithoutExtension: _propTypes.default.string,
    domainObject: _propTypes.default.object,
    isRestricted: _propTypes.default.bool
  }),
  product: _propTypes.default.object,
  onAddToCart: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  isListPricePriority: _propTypes.default.bool,
  stackDomainAndPrice: _propTypes.default.bool
};
var _default = exports.default = DomainRecommendation;